import React from 'react';

export default function Header() {
  return (
    <header className="header">
      <img src="/logo.png" alt="Key Element Dental Laboratory" className="header-logo" />
    </header>
  );
} 